import {IHttpService} from "angular";
import {Stock} from "../models/Stock";

export class StockScreenerService {

    public static id = "stockScreenerService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async stock(underlying: string): Promise<Stock> {
        const url = `/tradefloor/api/stockscreener?underlying=${underlying}`;
        const response = await this.$http.get<[Stock]>(url);
        return response.data![0];
    }
}
